import { CountriesListResponse, ICountryResponse } from '../interfaces/countriesResponse';
import { axiosAdmin } from './axios';
import { COUNTRIES_FETCH_PATH } from '../core/paths';

export namespace CountryService {
  export function getEntity(code: string): Promise<ICountryResponse> {
    return axiosAdmin.get<ICountryResponse>(COUNTRIES_FETCH_PATH + `/${code}`).then(({ data }) => data);
  }

  export function getList(): Promise<CountriesListResponse> {
    return axiosAdmin.get<CountriesListResponse>(COUNTRIES_FETCH_PATH).then(({data}) => data);
  }
}